import __pb_dep_0 from "google-protobuf";
import __pb_dep_1 from "./IM.BaseDefine_pb.js";

const __pbDeps = {
  "google-protobuf": __pb_dep_0,
  "./IM.BaseDefine_pb.js": __pb_dep_1,
};

const __pbModule = { exports: {} };
const exports = __pbModule.exports;
const module = __pbModule;

const require = (specifier) => {
  const resolved = __pbDeps[specifier];
  if (!resolved) {
    throw new Error(`Unsupported protobuf dependency in IM.Login_pb.js: ${specifier}`);
  }
  return resolved;
};

(function runGeneratedProtobufModule() {
  const root = globalThis;
  root.proto ??= {};
  var proto = root.proto;
  var COMPILED = false;

// source: IM.Login.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck
var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();
var IM_BaseDefine_pb = require('./IM.BaseDefine_pb.js');
goog.object.extend(proto, IM_BaseDefine_pb);
goog.exportSymbol('proto.IM.Login.IMDeviceTokenReq', null, global);
goog.exportSymbol('proto.IM.Login.IMDeviceTokenRsp', null, global);
goog.exportSymbol('proto.IM.Login.IMKickPCClientReq', null, global);
goog.exportSymbol('proto.IM.Login.IMKickPCClientRsp', null, global);
goog.exportSymbol('proto.IM.Login.IMKickUser', null, global);
goog.exportSymbol('proto.IM.Login.IMLoginReq', null, global);
goog.exportSymbol('proto.IM.Login.IMLoginRes', null, global);
goog.exportSymbol('proto.IM.Login.IMLogoutReq', null, global);
goog.exportSymbol('proto.IM.Login.IMLogoutRsp', null, global);
goog.exportSymbol('proto.IM.Login.IMMsgServReq', null, global);
goog.exportSymbol('proto.IM.Login.IMMsgServRsp', null, global);
goog.exportSymbol('proto.IM.Login.IMPushShieldReq', null, global);
goog.exportSymbol('proto.IM.Login.IMPushShieldRsp', null, global);
goog.exportSymbol('proto.IM.Login.IMQueryPushShieldReq', null, global);
goog.exportSymbol('proto.IM.Login.IMQueryPushShieldRsp', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Login.IMMsgServReq = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Login.IMMsgServReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Login.IMMsgServReq.displayName = 'proto.IM.Login.IMMsgServReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Login.IMMsgServRsp = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Login.IMMsgServRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Login.IMMsgServRsp.displayName = 'proto.IM.Login.IMMsgServRsp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Login.IMLoginReq = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Login.IMLoginReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Login.IMLoginReq.displayName = 'proto.IM.Login.IMLoginReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Login.IMLoginRes = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Login.IMLoginRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Login.IMLoginRes.displayName = 'proto.IM.Login.IMLoginRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Login.IMLogoutReq = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Login.IMLogoutReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Login.IMLogoutReq.displayName = 'proto.IM.Login.IMLogoutReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Login.IMLogoutRsp = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Login.IMLogoutRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Login.IMLogoutRsp.displayName = 'proto.IM.Login.IMLogoutRsp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Login.IMKickUser = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Login.IMKickUser, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Login.IMKickUser.displayName = 'proto.IM.Login.IMKickUser';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Login.IMDeviceTokenReq = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Login.IMDeviceTokenReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Login.IMDeviceTokenReq.displayName = 'proto.IM.Login.IMDeviceTokenReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Login.IMDeviceTokenRsp = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Login.IMDeviceTokenRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Login.IMDeviceTokenRsp.displayName = 'proto.IM.Login.IMDeviceTokenRsp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Login.IMKickPCClientReq = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Login.IMKickPCClientReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Login.IMKickPCClientReq.displayName = 'proto.IM.Login.IMKickPCClientReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Login.IMKickPCClientRsp = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Login.IMKickPCClientRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Login.IMKickPCClientRsp.displayName = 'proto.IM.Login.IMKickPCClientRsp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Login.IMPushShieldReq = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Login.IMPushShieldReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Login.IMPushShieldReq.displayName = 'proto.IM.Login.IMPushShieldReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Login.IMPushShieldRsp = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Login.IMPushShieldRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Login.IMPushShieldRsp.displayName = 'proto.IM.Login.IMPushShieldRsp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Login.IMQueryPushShieldReq = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Login.IMQueryPushShieldReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Login.IMQueryPushShieldReq.displayName = 'proto.IM.Login.IMQueryPushShieldReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Login.IMQueryPushShieldRsp = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Login.IMQueryPushShieldRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Login.IMQueryPushShieldRsp.displayName = 'proto.IM.Login.IMQueryPushShieldRsp';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Login.IMMsgServReq.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Login.IMMsgServReq.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Login.IMMsgServReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMMsgServReq.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Login.IMMsgServReq}
 */ proto.IM.Login.IMMsgServReq.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Login.IMMsgServReq;
    return proto.IM.Login.IMMsgServReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Login.IMMsgServReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Login.IMMsgServReq}
 */ proto.IM.Login.IMMsgServReq.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Login.IMMsgServReq.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Login.IMMsgServReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Login.IMMsgServReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMMsgServReq.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Login.IMMsgServRsp.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Login.IMMsgServRsp.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Login.IMMsgServRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMMsgServRsp.toObject = function(includeInstance, msg) {
        var f, obj = {
            resultCode: jspb.Message.getFieldWithDefault(msg, 1, 0),
            ip: jspb.Message.getFieldWithDefault(msg, 2, ""),
            port: jspb.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Login.IMMsgServRsp}
 */ proto.IM.Login.IMMsgServRsp.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Login.IMMsgServRsp;
    return proto.IM.Login.IMMsgServRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Login.IMMsgServRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Login.IMMsgServRsp}
 */ proto.IM.Login.IMMsgServRsp.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.IM.BaseDefine.ResultType} */ reader.readEnum();
                msg.setResultCode(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setIp(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readUint32();
                msg.setPort(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Login.IMMsgServRsp.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Login.IMMsgServRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Login.IMMsgServRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMMsgServRsp.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getResultCode();
    if (f !== 0.0) {
        writer.writeEnum(1, f);
    }
    f = /** @type {string} */ jspb.Message.getField(message, 2);
    if (f != null) {
        writer.writeString(2, f);
    }
    f = /** @type {number} */ jspb.Message.getField(message, 4);
    if (f != null) {
        writer.writeUint32(4, f);
    }
};
/**
 * optional IM.BaseDefine.ResultType result_code = 1;
 * @return {!proto.IM.BaseDefine.ResultType}
 */ proto.IM.Login.IMMsgServRsp.prototype.getResultCode = function() {
    return /** @type {!proto.IM.BaseDefine.ResultType} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.IM.BaseDefine.ResultType} value
 * @return {!proto.IM.Login.IMMsgServRsp} returns this
 */ proto.IM.Login.IMMsgServRsp.prototype.setResultCode = function(value) {
    return jspb.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional string ip = 2;
 * @return {string}
 */ proto.IM.Login.IMMsgServRsp.prototype.getIp = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.Login.IMMsgServRsp} returns this
 */ proto.IM.Login.IMMsgServRsp.prototype.setIp = function(value) {
    return jspb.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Login.IMMsgServRsp} returns this
 */ proto.IM.Login.IMMsgServRsp.prototype.clearIp = function() {
    return jspb.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Login.IMMsgServRsp.prototype.hasIp = function() {
    return jspb.Message.getField(this, 2) != null;
};
/**
 * optional uint32 port = 4;
 * @return {number}
 */ proto.IM.Login.IMMsgServRsp.prototype.getPort = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Login.IMMsgServRsp} returns this
 */ proto.IM.Login.IMMsgServRsp.prototype.setPort = function(value) {
    return jspb.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Login.IMMsgServRsp} returns this
 */ proto.IM.Login.IMMsgServRsp.prototype.clearPort = function() {
    return jspb.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Login.IMMsgServRsp.prototype.hasPort = function() {
    return jspb.Message.getField(this, 4) != null;
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Login.IMLoginReq.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Login.IMLoginReq.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Login.IMLoginReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMLoginReq.toObject = function(includeInstance, msg) {
        var f, obj = {
            imToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
            onlineStatus: jspb.Message.getFieldWithDefault(msg, 2, 0),
            clientType: jspb.Message.getFieldWithDefault(msg, 3, 0),
            clientVersion: jspb.Message.getFieldWithDefault(msg, 4, ""),
            deviceId: jspb.Message.getFieldWithDefault(msg, 5, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Login.IMLoginReq}
 */ proto.IM.Login.IMLoginReq.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Login.IMLoginReq;
    return proto.IM.Login.IMLoginReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Login.IMLoginReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Login.IMLoginReq}
 */ proto.IM.Login.IMLoginReq.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setImToken(value);
                break;
            case 2:
                var value = /** @type {!proto.IM.BaseDefine.UserStatType} */ reader.readEnum();
                msg.setOnlineStatus(value);
                break;
            case 3:
                var value = /** @type {!proto.IM.BaseDefine.ClientType} */ reader.readEnum();
                msg.setClientType(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setClientVersion(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setDeviceId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Login.IMLoginReq.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Login.IMLoginReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Login.IMLoginReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMLoginReq.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getImToken();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getOnlineStatus();
    if (f !== 0.0) {
        writer.writeEnum(2, f);
    }
    f = message.getClientType();
    if (f !== 0.0) {
        writer.writeEnum(3, f);
    }
    f = /** @type {string} */ jspb.Message.getField(message, 4);
    if (f != null) {
        writer.writeString(4, f);
    }
    f = message.getDeviceId();
    if (f.length > 0) {
        writer.writeString(5, f);
    }
};
/**
 * optional string im_token = 1;
 * @return {string}
 */ proto.IM.Login.IMLoginReq.prototype.getImToken = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.Login.IMLoginReq} returns this
 */ proto.IM.Login.IMLoginReq.prototype.setImToken = function(value) {
    return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional IM.BaseDefine.UserStatType online_status = 2;
 * @return {!proto.IM.BaseDefine.UserStatType}
 */ proto.IM.Login.IMLoginReq.prototype.getOnlineStatus = function() {
    return /** @type {!proto.IM.BaseDefine.UserStatType} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.IM.BaseDefine.UserStatType} value
 * @return {!proto.IM.Login.IMLoginReq} returns this
 */ proto.IM.Login.IMLoginReq.prototype.setOnlineStatus = function(value) {
    return jspb.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional IM.BaseDefine.ClientType client_type = 3;
 * @return {!proto.IM.BaseDefine.ClientType}
 */ proto.IM.Login.IMLoginReq.prototype.getClientType = function() {
    return /** @type {!proto.IM.BaseDefine.ClientType} */ jspb.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.IM.BaseDefine.ClientType} value
 * @return {!proto.IM.Login.IMLoginReq} returns this
 */ proto.IM.Login.IMLoginReq.prototype.setClientType = function(value) {
    return jspb.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional string client_version = 4;
 * @return {string}
 */ proto.IM.Login.IMLoginReq.prototype.getClientVersion = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.Login.IMLoginReq} returns this
 */ proto.IM.Login.IMLoginReq.prototype.setClientVersion = function(value) {
    return jspb.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Login.IMLoginReq} returns this
 */ proto.IM.Login.IMLoginReq.prototype.clearClientVersion = function() {
    return jspb.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Login.IMLoginReq.prototype.hasClientVersion = function() {
    return jspb.Message.getField(this, 4) != null;
};
/**
 * optional string device_id = 5;
 * @return {string}
 */ proto.IM.Login.IMLoginReq.prototype.getDeviceId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.Login.IMLoginReq} returns this
 */ proto.IM.Login.IMLoginReq.prototype.setDeviceId = function(value) {
    return jspb.Message.setProto3StringField(this, 5, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Login.IMLoginRes.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Login.IMLoginRes.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Login.IMLoginRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMLoginRes.toObject = function(includeInstance, msg) {
        var f, obj = {
            serverTime: jspb.Message.getFieldWithDefault(msg, 1, 0),
            resultCode: jspb.Message.getFieldWithDefault(msg, 2, 0),
            resultString: jspb.Message.getFieldWithDefault(msg, 3, ""),
            onlineStatus: jspb.Message.getFieldWithDefault(msg, 4, 0),
            authenticatedUser: (f = msg.getAuthenticatedUser()) && IM_BaseDefine_pb.UserIdentityRef.toObject(includeInstance, f)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Login.IMLoginRes}
 */ proto.IM.Login.IMLoginRes.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Login.IMLoginRes;
    return proto.IM.Login.IMLoginRes.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Login.IMLoginRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Login.IMLoginRes}
 */ proto.IM.Login.IMLoginRes.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setServerTime(value);
                break;
            case 2:
                var value = /** @type {!proto.IM.BaseDefine.ResultType} */ reader.readEnum();
                msg.setResultCode(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setResultString(value);
                break;
            case 4:
                var value = /** @type {!proto.IM.BaseDefine.UserStatType} */ reader.readEnum();
                msg.setOnlineStatus(value);
                break;
            case 6:
                var value = new IM_BaseDefine_pb.UserIdentityRef;
                reader.readMessage(value, IM_BaseDefine_pb.UserIdentityRef.deserializeBinaryFromReader);
                msg.setAuthenticatedUser(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Login.IMLoginRes.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Login.IMLoginRes.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Login.IMLoginRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMLoginRes.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getServerTime();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getResultCode();
    if (f !== 0.0) {
        writer.writeEnum(2, f);
    }
    f = /** @type {string} */ jspb.Message.getField(message, 3);
    if (f != null) {
        writer.writeString(3, f);
    }
    f = /** @type {!proto.IM.BaseDefine.UserStatType} */ jspb.Message.getField(message, 4);
    if (f != null) {
        writer.writeEnum(4, f);
    }
    f = message.getAuthenticatedUser();
    if (f != null) {
        writer.writeMessage(6, f, IM_BaseDefine_pb.UserIdentityRef.serializeBinaryToWriter);
    }
};
/**
 * optional uint32 server_time = 1;
 * @return {number}
 */ proto.IM.Login.IMLoginRes.prototype.getServerTime = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Login.IMLoginRes} returns this
 */ proto.IM.Login.IMLoginRes.prototype.setServerTime = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional IM.BaseDefine.ResultType result_code = 2;
 * @return {!proto.IM.BaseDefine.ResultType}
 */ proto.IM.Login.IMLoginRes.prototype.getResultCode = function() {
    return /** @type {!proto.IM.BaseDefine.ResultType} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.IM.BaseDefine.ResultType} value
 * @return {!proto.IM.Login.IMLoginRes} returns this
 */ proto.IM.Login.IMLoginRes.prototype.setResultCode = function(value) {
    return jspb.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional string result_string = 3;
 * @return {string}
 */ proto.IM.Login.IMLoginRes.prototype.getResultString = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.Login.IMLoginRes} returns this
 */ proto.IM.Login.IMLoginRes.prototype.setResultString = function(value) {
    return jspb.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Login.IMLoginRes} returns this
 */ proto.IM.Login.IMLoginRes.prototype.clearResultString = function() {
    return jspb.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Login.IMLoginRes.prototype.hasResultString = function() {
    return jspb.Message.getField(this, 3) != null;
};
/**
 * optional IM.BaseDefine.UserStatType online_status = 4;
 * @return {!proto.IM.BaseDefine.UserStatType}
 */ proto.IM.Login.IMLoginRes.prototype.getOnlineStatus = function() {
    return /** @type {!proto.IM.BaseDefine.UserStatType} */ jspb.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.IM.BaseDefine.UserStatType} value
 * @return {!proto.IM.Login.IMLoginRes} returns this
 */ proto.IM.Login.IMLoginRes.prototype.setOnlineStatus = function(value) {
    return jspb.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Login.IMLoginRes} returns this
 */ proto.IM.Login.IMLoginRes.prototype.clearOnlineStatus = function() {
    return jspb.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Login.IMLoginRes.prototype.hasOnlineStatus = function() {
    return jspb.Message.getField(this, 4) != null;
};
/**
 * optional IM.BaseDefine.UserIdentityRef authenticated_user = 6;
 * @return {?proto.IM.BaseDefine.UserIdentityRef}
 */ proto.IM.Login.IMLoginRes.prototype.getAuthenticatedUser = function() {
    return /** @type{?proto.IM.BaseDefine.UserIdentityRef} */ jspb.Message.getWrapperField(this, IM_BaseDefine_pb.UserIdentityRef, 6);
};
/**
 * @param {?proto.IM.BaseDefine.UserIdentityRef|undefined} value
 * @return {!proto.IM.Login.IMLoginRes} returns this
*/ proto.IM.Login.IMLoginRes.prototype.setAuthenticatedUser = function(value) {
    return jspb.Message.setWrapperField(this, 6, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.IM.Login.IMLoginRes} returns this
 */ proto.IM.Login.IMLoginRes.prototype.clearAuthenticatedUser = function() {
    return this.setAuthenticatedUser(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Login.IMLoginRes.prototype.hasAuthenticatedUser = function() {
    return jspb.Message.getField(this, 6) != null;
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Login.IMLogoutReq.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Login.IMLogoutReq.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Login.IMLogoutReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMLogoutReq.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Login.IMLogoutReq}
 */ proto.IM.Login.IMLogoutReq.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Login.IMLogoutReq;
    return proto.IM.Login.IMLogoutReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Login.IMLogoutReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Login.IMLogoutReq}
 */ proto.IM.Login.IMLogoutReq.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Login.IMLogoutReq.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Login.IMLogoutReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Login.IMLogoutReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMLogoutReq.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Login.IMLogoutRsp.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Login.IMLogoutRsp.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Login.IMLogoutRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMLogoutRsp.toObject = function(includeInstance, msg) {
        var f, obj = {
            resultCode: jspb.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Login.IMLogoutRsp}
 */ proto.IM.Login.IMLogoutRsp.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Login.IMLogoutRsp;
    return proto.IM.Login.IMLogoutRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Login.IMLogoutRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Login.IMLogoutRsp}
 */ proto.IM.Login.IMLogoutRsp.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setResultCode(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Login.IMLogoutRsp.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Login.IMLogoutRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Login.IMLogoutRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMLogoutRsp.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getResultCode();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
};
/**
 * optional uint32 result_code = 1;
 * @return {number}
 */ proto.IM.Login.IMLogoutRsp.prototype.getResultCode = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Login.IMLogoutRsp} returns this
 */ proto.IM.Login.IMLogoutRsp.prototype.setResultCode = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Login.IMKickUser.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Login.IMKickUser.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Login.IMKickUser} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMKickUser.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            kickReason: jspb.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Login.IMKickUser}
 */ proto.IM.Login.IMKickUser.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Login.IMKickUser;
    return proto.IM.Login.IMKickUser.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Login.IMKickUser} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Login.IMKickUser}
 */ proto.IM.Login.IMKickUser.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 2:
                var value = /** @type {!proto.IM.BaseDefine.KickReasonType} */ reader.readEnum();
                msg.setKickReason(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Login.IMKickUser.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Login.IMKickUser.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Login.IMKickUser} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMKickUser.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getKickReason();
    if (f !== 0.0) {
        writer.writeEnum(2, f);
    }
};
/**
 * optional uint32 user_id = 1;
 * @return {number}
 */ proto.IM.Login.IMKickUser.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Login.IMKickUser} returns this
 */ proto.IM.Login.IMKickUser.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional IM.BaseDefine.KickReasonType kick_reason = 2;
 * @return {!proto.IM.BaseDefine.KickReasonType}
 */ proto.IM.Login.IMKickUser.prototype.getKickReason = function() {
    return /** @type {!proto.IM.BaseDefine.KickReasonType} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.IM.BaseDefine.KickReasonType} value
 * @return {!proto.IM.Login.IMKickUser} returns this
 */ proto.IM.Login.IMKickUser.prototype.setKickReason = function(value) {
    return jspb.Message.setProto3EnumField(this, 2, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Login.IMDeviceTokenReq.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Login.IMDeviceTokenReq.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Login.IMDeviceTokenReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMDeviceTokenReq.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            deviceToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
            clientType: jspb.Message.getFieldWithDefault(msg, 3, 0),
            attachData: msg.getAttachData_asB64()
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Login.IMDeviceTokenReq}
 */ proto.IM.Login.IMDeviceTokenReq.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Login.IMDeviceTokenReq;
    return proto.IM.Login.IMDeviceTokenReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Login.IMDeviceTokenReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Login.IMDeviceTokenReq}
 */ proto.IM.Login.IMDeviceTokenReq.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setDeviceToken(value);
                break;
            case 3:
                var value = /** @type {!proto.IM.BaseDefine.ClientType} */ reader.readEnum();
                msg.setClientType(value);
                break;
            case 20:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setAttachData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Login.IMDeviceTokenReq.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Login.IMDeviceTokenReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Login.IMDeviceTokenReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMDeviceTokenReq.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getDeviceToken();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
    f = /** @type {!proto.IM.BaseDefine.ClientType} */ jspb.Message.getField(message, 3);
    if (f != null) {
        writer.writeEnum(3, f);
    }
    f = /** @type {!(string|Uint8Array)} */ jspb.Message.getField(message, 20);
    if (f != null) {
        writer.writeBytes(20, f);
    }
};
/**
 * optional uint32 user_id = 1;
 * @return {number}
 */ proto.IM.Login.IMDeviceTokenReq.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Login.IMDeviceTokenReq} returns this
 */ proto.IM.Login.IMDeviceTokenReq.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string device_token = 2;
 * @return {string}
 */ proto.IM.Login.IMDeviceTokenReq.prototype.getDeviceToken = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.Login.IMDeviceTokenReq} returns this
 */ proto.IM.Login.IMDeviceTokenReq.prototype.setDeviceToken = function(value) {
    return jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional IM.BaseDefine.ClientType client_type = 3;
 * @return {!proto.IM.BaseDefine.ClientType}
 */ proto.IM.Login.IMDeviceTokenReq.prototype.getClientType = function() {
    return /** @type {!proto.IM.BaseDefine.ClientType} */ jspb.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.IM.BaseDefine.ClientType} value
 * @return {!proto.IM.Login.IMDeviceTokenReq} returns this
 */ proto.IM.Login.IMDeviceTokenReq.prototype.setClientType = function(value) {
    return jspb.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Login.IMDeviceTokenReq} returns this
 */ proto.IM.Login.IMDeviceTokenReq.prototype.clearClientType = function() {
    return jspb.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Login.IMDeviceTokenReq.prototype.hasClientType = function() {
    return jspb.Message.getField(this, 3) != null;
};
/**
 * optional bytes attach_data = 20;
 * @return {string}
 */ proto.IM.Login.IMDeviceTokenReq.prototype.getAttachData = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 20, "");
};
/**
 * optional bytes attach_data = 20;
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {string}
 */ proto.IM.Login.IMDeviceTokenReq.prototype.getAttachData_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getAttachData());
};
/**
 * optional bytes attach_data = 20;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {!Uint8Array}
 */ proto.IM.Login.IMDeviceTokenReq.prototype.getAttachData_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getAttachData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Login.IMDeviceTokenReq} returns this
 */ proto.IM.Login.IMDeviceTokenReq.prototype.setAttachData = function(value) {
    return jspb.Message.setField(this, 20, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Login.IMDeviceTokenReq} returns this
 */ proto.IM.Login.IMDeviceTokenReq.prototype.clearAttachData = function() {
    return jspb.Message.setField(this, 20, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Login.IMDeviceTokenReq.prototype.hasAttachData = function() {
    return jspb.Message.getField(this, 20) != null;
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Login.IMDeviceTokenRsp.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Login.IMDeviceTokenRsp.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Login.IMDeviceTokenRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMDeviceTokenRsp.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            attachData: msg.getAttachData_asB64()
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Login.IMDeviceTokenRsp}
 */ proto.IM.Login.IMDeviceTokenRsp.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Login.IMDeviceTokenRsp;
    return proto.IM.Login.IMDeviceTokenRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Login.IMDeviceTokenRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Login.IMDeviceTokenRsp}
 */ proto.IM.Login.IMDeviceTokenRsp.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 20:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setAttachData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Login.IMDeviceTokenRsp.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Login.IMDeviceTokenRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Login.IMDeviceTokenRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMDeviceTokenRsp.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = /** @type {!(string|Uint8Array)} */ jspb.Message.getField(message, 20);
    if (f != null) {
        writer.writeBytes(20, f);
    }
};
/**
 * optional uint32 user_id = 1;
 * @return {number}
 */ proto.IM.Login.IMDeviceTokenRsp.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Login.IMDeviceTokenRsp} returns this
 */ proto.IM.Login.IMDeviceTokenRsp.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional bytes attach_data = 20;
 * @return {string}
 */ proto.IM.Login.IMDeviceTokenRsp.prototype.getAttachData = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 20, "");
};
/**
 * optional bytes attach_data = 20;
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {string}
 */ proto.IM.Login.IMDeviceTokenRsp.prototype.getAttachData_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getAttachData());
};
/**
 * optional bytes attach_data = 20;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {!Uint8Array}
 */ proto.IM.Login.IMDeviceTokenRsp.prototype.getAttachData_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getAttachData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Login.IMDeviceTokenRsp} returns this
 */ proto.IM.Login.IMDeviceTokenRsp.prototype.setAttachData = function(value) {
    return jspb.Message.setField(this, 20, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Login.IMDeviceTokenRsp} returns this
 */ proto.IM.Login.IMDeviceTokenRsp.prototype.clearAttachData = function() {
    return jspb.Message.setField(this, 20, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Login.IMDeviceTokenRsp.prototype.hasAttachData = function() {
    return jspb.Message.getField(this, 20) != null;
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Login.IMKickPCClientReq.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Login.IMKickPCClientReq.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Login.IMKickPCClientReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMKickPCClientReq.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: jspb.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Login.IMKickPCClientReq}
 */ proto.IM.Login.IMKickPCClientReq.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Login.IMKickPCClientReq;
    return proto.IM.Login.IMKickPCClientReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Login.IMKickPCClientReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Login.IMKickPCClientReq}
 */ proto.IM.Login.IMKickPCClientReq.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Login.IMKickPCClientReq.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Login.IMKickPCClientReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Login.IMKickPCClientReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMKickPCClientReq.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
};
/**
 * optional uint32 user_id = 1;
 * @return {number}
 */ proto.IM.Login.IMKickPCClientReq.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Login.IMKickPCClientReq} returns this
 */ proto.IM.Login.IMKickPCClientReq.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Login.IMKickPCClientRsp.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Login.IMKickPCClientRsp.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Login.IMKickPCClientRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMKickPCClientRsp.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            resultCode: jspb.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Login.IMKickPCClientRsp}
 */ proto.IM.Login.IMKickPCClientRsp.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Login.IMKickPCClientRsp;
    return proto.IM.Login.IMKickPCClientRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Login.IMKickPCClientRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Login.IMKickPCClientRsp}
 */ proto.IM.Login.IMKickPCClientRsp.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setResultCode(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Login.IMKickPCClientRsp.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Login.IMKickPCClientRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Login.IMKickPCClientRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMKickPCClientRsp.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getResultCode();
    if (f !== 0) {
        writer.writeUint32(2, f);
    }
};
/**
 * optional uint32 user_id = 1;
 * @return {number}
 */ proto.IM.Login.IMKickPCClientRsp.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Login.IMKickPCClientRsp} returns this
 */ proto.IM.Login.IMKickPCClientRsp.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional uint32 result_code = 2;
 * @return {number}
 */ proto.IM.Login.IMKickPCClientRsp.prototype.getResultCode = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Login.IMKickPCClientRsp} returns this
 */ proto.IM.Login.IMKickPCClientRsp.prototype.setResultCode = function(value) {
    return jspb.Message.setProto3IntField(this, 2, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Login.IMPushShieldReq.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Login.IMPushShieldReq.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Login.IMPushShieldReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMPushShieldReq.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            shieldStatus: jspb.Message.getFieldWithDefault(msg, 2, 0),
            attachData: msg.getAttachData_asB64()
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Login.IMPushShieldReq}
 */ proto.IM.Login.IMPushShieldReq.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Login.IMPushShieldReq;
    return proto.IM.Login.IMPushShieldReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Login.IMPushShieldReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Login.IMPushShieldReq}
 */ proto.IM.Login.IMPushShieldReq.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setShieldStatus(value);
                break;
            case 20:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setAttachData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Login.IMPushShieldReq.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Login.IMPushShieldReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Login.IMPushShieldReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMPushShieldReq.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getShieldStatus();
    if (f !== 0) {
        writer.writeUint32(2, f);
    }
    f = /** @type {!(string|Uint8Array)} */ jspb.Message.getField(message, 20);
    if (f != null) {
        writer.writeBytes(20, f);
    }
};
/**
 * optional uint32 user_id = 1;
 * @return {number}
 */ proto.IM.Login.IMPushShieldReq.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Login.IMPushShieldReq} returns this
 */ proto.IM.Login.IMPushShieldReq.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional uint32 shield_status = 2;
 * @return {number}
 */ proto.IM.Login.IMPushShieldReq.prototype.getShieldStatus = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Login.IMPushShieldReq} returns this
 */ proto.IM.Login.IMPushShieldReq.prototype.setShieldStatus = function(value) {
    return jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional bytes attach_data = 20;
 * @return {string}
 */ proto.IM.Login.IMPushShieldReq.prototype.getAttachData = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 20, "");
};
/**
 * optional bytes attach_data = 20;
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {string}
 */ proto.IM.Login.IMPushShieldReq.prototype.getAttachData_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getAttachData());
};
/**
 * optional bytes attach_data = 20;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {!Uint8Array}
 */ proto.IM.Login.IMPushShieldReq.prototype.getAttachData_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getAttachData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Login.IMPushShieldReq} returns this
 */ proto.IM.Login.IMPushShieldReq.prototype.setAttachData = function(value) {
    return jspb.Message.setField(this, 20, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Login.IMPushShieldReq} returns this
 */ proto.IM.Login.IMPushShieldReq.prototype.clearAttachData = function() {
    return jspb.Message.setField(this, 20, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Login.IMPushShieldReq.prototype.hasAttachData = function() {
    return jspb.Message.getField(this, 20) != null;
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Login.IMPushShieldRsp.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Login.IMPushShieldRsp.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Login.IMPushShieldRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMPushShieldRsp.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            resultCode: jspb.Message.getFieldWithDefault(msg, 2, 0),
            shieldStatus: jspb.Message.getFieldWithDefault(msg, 3, 0),
            attachData: msg.getAttachData_asB64()
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Login.IMPushShieldRsp}
 */ proto.IM.Login.IMPushShieldRsp.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Login.IMPushShieldRsp;
    return proto.IM.Login.IMPushShieldRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Login.IMPushShieldRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Login.IMPushShieldRsp}
 */ proto.IM.Login.IMPushShieldRsp.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setResultCode(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setShieldStatus(value);
                break;
            case 20:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setAttachData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Login.IMPushShieldRsp.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Login.IMPushShieldRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Login.IMPushShieldRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMPushShieldRsp.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getResultCode();
    if (f !== 0) {
        writer.writeUint32(2, f);
    }
    f = /** @type {number} */ jspb.Message.getField(message, 3);
    if (f != null) {
        writer.writeUint32(3, f);
    }
    f = /** @type {!(string|Uint8Array)} */ jspb.Message.getField(message, 20);
    if (f != null) {
        writer.writeBytes(20, f);
    }
};
/**
 * optional uint32 user_id = 1;
 * @return {number}
 */ proto.IM.Login.IMPushShieldRsp.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Login.IMPushShieldRsp} returns this
 */ proto.IM.Login.IMPushShieldRsp.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional uint32 result_code = 2;
 * @return {number}
 */ proto.IM.Login.IMPushShieldRsp.prototype.getResultCode = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Login.IMPushShieldRsp} returns this
 */ proto.IM.Login.IMPushShieldRsp.prototype.setResultCode = function(value) {
    return jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional uint32 shield_status = 3;
 * @return {number}
 */ proto.IM.Login.IMPushShieldRsp.prototype.getShieldStatus = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Login.IMPushShieldRsp} returns this
 */ proto.IM.Login.IMPushShieldRsp.prototype.setShieldStatus = function(value) {
    return jspb.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Login.IMPushShieldRsp} returns this
 */ proto.IM.Login.IMPushShieldRsp.prototype.clearShieldStatus = function() {
    return jspb.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Login.IMPushShieldRsp.prototype.hasShieldStatus = function() {
    return jspb.Message.getField(this, 3) != null;
};
/**
 * optional bytes attach_data = 20;
 * @return {string}
 */ proto.IM.Login.IMPushShieldRsp.prototype.getAttachData = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 20, "");
};
/**
 * optional bytes attach_data = 20;
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {string}
 */ proto.IM.Login.IMPushShieldRsp.prototype.getAttachData_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getAttachData());
};
/**
 * optional bytes attach_data = 20;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {!Uint8Array}
 */ proto.IM.Login.IMPushShieldRsp.prototype.getAttachData_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getAttachData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Login.IMPushShieldRsp} returns this
 */ proto.IM.Login.IMPushShieldRsp.prototype.setAttachData = function(value) {
    return jspb.Message.setField(this, 20, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Login.IMPushShieldRsp} returns this
 */ proto.IM.Login.IMPushShieldRsp.prototype.clearAttachData = function() {
    return jspb.Message.setField(this, 20, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Login.IMPushShieldRsp.prototype.hasAttachData = function() {
    return jspb.Message.getField(this, 20) != null;
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Login.IMQueryPushShieldReq.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Login.IMQueryPushShieldReq.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Login.IMQueryPushShieldReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMQueryPushShieldReq.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            attachData: msg.getAttachData_asB64()
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Login.IMQueryPushShieldReq}
 */ proto.IM.Login.IMQueryPushShieldReq.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Login.IMQueryPushShieldReq;
    return proto.IM.Login.IMQueryPushShieldReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Login.IMQueryPushShieldReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Login.IMQueryPushShieldReq}
 */ proto.IM.Login.IMQueryPushShieldReq.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 20:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setAttachData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Login.IMQueryPushShieldReq.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Login.IMQueryPushShieldReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Login.IMQueryPushShieldReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMQueryPushShieldReq.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = /** @type {!(string|Uint8Array)} */ jspb.Message.getField(message, 20);
    if (f != null) {
        writer.writeBytes(20, f);
    }
};
/**
 * optional uint32 user_id = 1;
 * @return {number}
 */ proto.IM.Login.IMQueryPushShieldReq.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Login.IMQueryPushShieldReq} returns this
 */ proto.IM.Login.IMQueryPushShieldReq.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional bytes attach_data = 20;
 * @return {string}
 */ proto.IM.Login.IMQueryPushShieldReq.prototype.getAttachData = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 20, "");
};
/**
 * optional bytes attach_data = 20;
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {string}
 */ proto.IM.Login.IMQueryPushShieldReq.prototype.getAttachData_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getAttachData());
};
/**
 * optional bytes attach_data = 20;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {!Uint8Array}
 */ proto.IM.Login.IMQueryPushShieldReq.prototype.getAttachData_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getAttachData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Login.IMQueryPushShieldReq} returns this
 */ proto.IM.Login.IMQueryPushShieldReq.prototype.setAttachData = function(value) {
    return jspb.Message.setField(this, 20, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Login.IMQueryPushShieldReq} returns this
 */ proto.IM.Login.IMQueryPushShieldReq.prototype.clearAttachData = function() {
    return jspb.Message.setField(this, 20, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Login.IMQueryPushShieldReq.prototype.hasAttachData = function() {
    return jspb.Message.getField(this, 20) != null;
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Login.IMQueryPushShieldRsp.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Login.IMQueryPushShieldRsp.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Login.IMQueryPushShieldRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMQueryPushShieldRsp.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            resultCode: jspb.Message.getFieldWithDefault(msg, 2, 0),
            shieldStatus: jspb.Message.getFieldWithDefault(msg, 3, 0),
            attachData: msg.getAttachData_asB64()
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Login.IMQueryPushShieldRsp}
 */ proto.IM.Login.IMQueryPushShieldRsp.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Login.IMQueryPushShieldRsp;
    return proto.IM.Login.IMQueryPushShieldRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Login.IMQueryPushShieldRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Login.IMQueryPushShieldRsp}
 */ proto.IM.Login.IMQueryPushShieldRsp.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setResultCode(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setShieldStatus(value);
                break;
            case 20:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setAttachData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Login.IMQueryPushShieldRsp.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Login.IMQueryPushShieldRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Login.IMQueryPushShieldRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Login.IMQueryPushShieldRsp.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getResultCode();
    if (f !== 0) {
        writer.writeUint32(2, f);
    }
    f = /** @type {number} */ jspb.Message.getField(message, 3);
    if (f != null) {
        writer.writeUint32(3, f);
    }
    f = /** @type {!(string|Uint8Array)} */ jspb.Message.getField(message, 20);
    if (f != null) {
        writer.writeBytes(20, f);
    }
};
/**
 * optional uint32 user_id = 1;
 * @return {number}
 */ proto.IM.Login.IMQueryPushShieldRsp.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Login.IMQueryPushShieldRsp} returns this
 */ proto.IM.Login.IMQueryPushShieldRsp.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional uint32 result_code = 2;
 * @return {number}
 */ proto.IM.Login.IMQueryPushShieldRsp.prototype.getResultCode = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Login.IMQueryPushShieldRsp} returns this
 */ proto.IM.Login.IMQueryPushShieldRsp.prototype.setResultCode = function(value) {
    return jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional uint32 shield_status = 3;
 * @return {number}
 */ proto.IM.Login.IMQueryPushShieldRsp.prototype.getShieldStatus = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Login.IMQueryPushShieldRsp} returns this
 */ proto.IM.Login.IMQueryPushShieldRsp.prototype.setShieldStatus = function(value) {
    return jspb.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Login.IMQueryPushShieldRsp} returns this
 */ proto.IM.Login.IMQueryPushShieldRsp.prototype.clearShieldStatus = function() {
    return jspb.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Login.IMQueryPushShieldRsp.prototype.hasShieldStatus = function() {
    return jspb.Message.getField(this, 3) != null;
};
/**
 * optional bytes attach_data = 20;
 * @return {string}
 */ proto.IM.Login.IMQueryPushShieldRsp.prototype.getAttachData = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 20, "");
};
/**
 * optional bytes attach_data = 20;
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {string}
 */ proto.IM.Login.IMQueryPushShieldRsp.prototype.getAttachData_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getAttachData());
};
/**
 * optional bytes attach_data = 20;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {!Uint8Array}
 */ proto.IM.Login.IMQueryPushShieldRsp.prototype.getAttachData_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getAttachData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Login.IMQueryPushShieldRsp} returns this
 */ proto.IM.Login.IMQueryPushShieldRsp.prototype.setAttachData = function(value) {
    return jspb.Message.setField(this, 20, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Login.IMQueryPushShieldRsp} returns this
 */ proto.IM.Login.IMQueryPushShieldRsp.prototype.clearAttachData = function() {
    return jspb.Message.setField(this, 20, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Login.IMQueryPushShieldRsp.prototype.hasAttachData = function() {
    return jspb.Message.getField(this, 20) != null;
};
goog.object.extend(exports, proto.IM.Login);

})();

export default module.exports;
